export default [
  {
    header: 'Content',
    resource: 'Blog',
    action: 'read',
  },
  {
    title: 'Blog',
    icon: 'BookOpenIcon',
    tagVariant: 'light-warning',
    resource: 'Blog',
    action: 'read',
    children: [
      {
        title: 'Blog',
        route: 'blog-read',  
        resource: 'Blog',
        action: 'read',
      },
      {
        title: 'Category',
        route: 'blog-category-read',
        resource: 'Blog Categories',
        action: 'read',
      },
    ]
  },
  {
    title: 'Storage',
    icon: 'FileTextIcon',
    route: 'files-read',  
    tagVariant: 'light-warning',
    resource: 'Pages',
    action: 'read',
  },
  {
    title: 'Products',
    icon: 'BoxIcon',
    tagVariant: 'light-warning',
    resource: 'Products',
    action: 'read',
    children: [
      {
        title: 'Products',
        route: 'products-read',
        resource: 'Products',
        action: 'read',
      },
      {
        title: 'Category',
        route: 'products-category-read',
        resource: 'Product Categories',
        action: 'read',
      },
    ]
  },
  {
    title: 'Service',
    iconflat: 'services',
    tagVariant: 'light-warning',
    resource: 'Services',
    action: 'read',
    children: [
      {
        title: 'Services',
        route: 'services-read',
        resource: 'Services',
        action: 'read',
      },
      {
        title: 'Category',
        route: 'services-category-read',
        resource: 'Services Categories',
        action: 'read',
      },
    ]
  },
  {
    title: 'Socials',
    iconflat: 'social',
    tagVariant: 'light-warning',
    resource: 'Socials',
    action: 'read',
    children: [
      {
        title: 'Socials',
        route: 'socials-read',
        resource: 'Socials',
        action: 'read',
      },
      {
        title: 'Category',
        route: 'socials-category-read',
        resource: 'Social Categories',
        action: 'read',
      },
    ]
  },
  // {
  //   title: 'Packages',
  //   iconflat: 'package',
  //   route: 'packages-read',
  //   tagVariant: 'light-warning',
  //   resource: 'Packages',
  //   action: 'read',
  // },
  {
    title: 'Page',
    icon: 'FileTextIcon',
    route: 'pages-read',  
    tagVariant: 'light-warning',
    resource: 'Pages',
    action: 'read',
  },
  {
    title: 'Social Reviews',
    icon: 'MessageCircleIcon',
    route: 'comment-read',  
    tagVariant: 'light-warning',
    resource: 'Comment',
    action: 'read',
  },
  {
    title: 'Banner',
    icon: 'ImageIcon',
    route: 'banner-read',  
    tagVariant: 'light-warning',
    resource: 'Banner',
    action: 'read',
  },
  {
    title: 'Navigation',
    icon: 'NavigationIcon',
    route: 'navigation-read',  
    tagVariant: 'light-warning',
    resource: 'Navigation',
    action: 'read',
  },
]